import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { ApplicationState, AppState } from '../../../store';
import { withSnackbar, ProviderContext } from 'notistack';
import { ITranslatorService } from '../../../services/Interfaces/ITranslatorService';
import { ApplicationContext, AppContext } from '../../../context/Contexts';
import {
  Tooltip,
  Box,
  Button,
  IconButton,
  Dialog,
  DialogTitle,
  Grid,
  Typography,
  DialogContent
} from '@material-ui/core';
import { ScaleLoader } from 'react-spinners';
import AddCircleTwoToneIcon from '@material-ui/icons/AddCircleTwoTone';
import { RouteComponentProps } from 'react-router';
import { ValidatorForm, TextValidator } from 'react-material-ui-form-validator';
import Autocomplete from '@material-ui/lab/Autocomplete';
import MUIDataTable, {
  SelectableRows,
  MUIDataTableMeta,
  MUIDataTableColumnOptions
} from 'mui-datatables';
import { MUITranslations } from '../../../helpers/MUITableTranslations';
import CloseIcon from '@material-ui/icons/Close';
import DeleteOutlineTwoToneIcon from '@material-ui/icons/DeleteOutlineTwoTone';
import { ReferentialCode } from '../../../helpers/Constants';
import Referentials from '../../../helpers/Referentials.json';
import { IReferential } from '../../../interfaces/IReferential';
import moment from 'moment';
import { IReferentialService } from '../../../services/Interfaces/IReferentialService';
import EditOutlinedIcon from '@material-ui/icons/EditOutlined';
import { CountryBuffer } from '../../../interfaces/Organization';
import { IOrganizationService } from '../../../services/Interfaces/IOrganizationService';
import NumberFormat from 'react-number-format';

interface ICountryBufferComponentState {
  newCountryBuffer: CountryBuffer;
  countryBuffers: CountryBuffer[];
  isLoading: boolean;
  isDialogOpen: boolean;
  newCountryBufferId: number | null;
  countryList: IReferential[];
}
type ICountryBufferComponentProps = { appState: AppState } & ProviderContext &
  RouteComponentProps<{ id: string; workflowId: string }>;
class CountryBufferComponent extends React.PureComponent<
  ICountryBufferComponentProps,
  ICountryBufferComponentState
> {
  private translatorService!: ITranslatorService;
  private organizationService!: IOrganizationService;
  private appReferentialService!: IReferentialService;
  static contextType = ApplicationContext;
  private newCountryBuffer = {
    id: 0,
    countryId: 0,
    country: null,
    value: 0
  } as CountryBuffer;

  state = {
    isLoading: false,
    isDialogOpen: false,
    newCountryBuffer: this.newCountryBuffer,
    countryBuffers: [],
    newCountryBufferId: null,
    countryList: [] as IReferential[]
  } as ICountryBufferComponentState;

  public componentDidMount() {
    this.setState(
      {
        isLoading: true
      },
      async () => {
        await this.loadCountryBuffers();
      }
    );
  }

  loadCountryBuffers = async () => {
    const countryRef = Referentials.referential.find(
      (item) => item.code === ReferentialCode.Country
    );
    const [countryBuffers, countryList] = await Promise.all([
      this.organizationService.GetCountryBuffers(),
      this.appReferentialService.Get(countryRef!.baseUrl)
    ]);

    this.setState({
      countryBuffers: countryBuffers,
      isLoading: false,
      newCountryBuffer: { ...this.newCountryBuffer },
      countryList: countryList
    });
  };

  private handleCountryChange = (newValue: IReferential | null) => {
    this.setState({
      newCountryBuffer: {
        ...this.state.newCountryBuffer,
        country: newValue,
        countryId: newValue !== null ? newValue!.id : 0
      }
    });
  };

  private handleValueChange = (value: string) => {
    this.setState({
      newCountryBuffer: {
        ...this.state.newCountryBuffer,
        value: parseFloat(value)
      }
    });
  };

  public saveCountryBuffer = async () => {
    if (this.state.newCountryBufferId === null) {
      try {
        await this.organizationService.AddCountryBuffer(this.state.newCountryBuffer);
        await this.loadCountryBuffers();
        this.closeDialog();
        this.props.enqueueSnackbar(this.translatorService.Tranlate('SUCCES_MSG', 'OK'), {
          variant: 'success'
        });
      } catch (error) {
        this.props.enqueueSnackbar(this.translatorService.Tranlate('ERROR_MSG', 'Eroare'), {
          variant: 'error'
        });
      }
    } else {
      try {
        await this.organizationService.UpdateCountryBuffer(this.state.newCountryBuffer);
        await this.loadCountryBuffers();
        this.closeDialog();
        this.props.enqueueSnackbar(this.translatorService.Tranlate('SUCCES_MSG', 'OK'), {
          variant: 'success'
        });
      } catch (error) {
        this.props.enqueueSnackbar(this.translatorService.Tranlate('ERROR_MSG', 'Eroare'), {
          variant: 'error'
        });
      }
    }
  };

  NumberFormatCustom = (props: any) => {
    const { inputRef, onChange, ...other } = props;
    return (
      <NumberFormat
        {...other}
        getInputRef={inputRef}
        onValueChange={(values: any) => {
          onChange({
            target: {
              value: values.value
            },
            currentTarget: {
              value: values.value
            }
          });
        }}
        allowNegative={false}
        thousandSeparator={false}
        decimalScale={2}
      />
    );
  };

  public renderAddForm() {
    return (
      <ValidatorForm onSubmit={this.saveCountryBuffer} instantValidate={true}>
        <Box mb={2}>
          <Autocomplete
            id="country"
            fullWidth
            options={this.state.countryList}
            value={this.state.newCountryBuffer.country}
            onChange={(e: any, newValue: IReferential | null) =>
              this.handleCountryChange(newValue)
            }
            getOptionLabel={(option: IReferential) => option.displayName || ''}
            renderInput={(params) => (
              <TextValidator
                {...params}
                name="country"
                value={this.state.newCountryBuffer.country || ''}
                label={this.translatorService.Tranlate(
                  'EDIT_ORGANIZATION_COUNTRY_LABEL',
                  'Tara'
                )}
                fullWidth
                validators={[]}
                errorMessages={[
                  this.translatorService.Tranlate(
                    'VALIDATORS_REQUIRED',
                    'Campul este obligatoriu'
                  )
                ]}
              />
            )}
          />
        </Box>
        <Box mb={2}>
          <TextValidator
            fullWidth
            name="value"
            id="value"
            value={this.state.newCountryBuffer.value || ''}
            onChange={(e: any) => this.handleValueChange(e.target.value)}
            label={this.translatorService.Tranlate(
              'COUNTRY_BUFFER_VALUE_LABEL',
              'Nr. zile'
            )}
            validators={['required', 'minNumber:0']}
            errorMessages={[
              this.translatorService.Tranlate('VALIDATORS_REQUIRED', 'Campul este obligatoriu')
            ]}
            InputProps={{
              inputComponent: this.NumberFormatCustom
            }}
          />
        </Box>

        <div className="text-right">
          <Button
            className="m-2"
            variant="outlined"
            color="default"
            onClick={this.closeDialog}
          >
            {this.translatorService.Tranlate('EDIT_ORGANIZATION_CANCEL_BTN', 'Anuleaza')}
          </Button>
          <Button className="m-2" variant="contained" color="secondary" type="submit">
            {this.translatorService.Tranlate('EDIT_ORGANIZATION_SAVE_BTN', 'Salveaza')}
          </Button>
        </div>
    </ValidatorForm>
    );
  }
  getColumns = () => {
    const columns = [
      {
        name: 'id',
        options: { display: 'excluded', filter: false } as MUIDataTableColumnOptions
      },
      {
        name: 'country',
        label: this.translatorService.Tranlate('ORGANIZATIONS_COUNTRY_HEADER', 'Tara'),
        options: {
          sort: true,
          customSort: (a: IReferential, b: IReferential) => {
            debugger;
            return a.name!.localeCompare(b.name!);
          },
          customBodyRender: (value: IReferential) => {
            return value ? value.displayName : '';
          }
        } as MUIDataTableColumnOptions
      },
      {
        name: 'value',
        label: this.translatorService.Tranlate(
          'COUNTRY_BUFFER_VALUE_LABEL',
          'Nr. zile'
        )
      },
      {
        name: 'dateModification',
        label: this.translatorService.Tranlate('USERS_DATE_MODIFICATION_HEADER', 'Data Modificare'),
        options: {
          filter: false,
          sortDirection: 'desc',
          customBodyRender: (value: Date) =>
            moment.utc(value).local().format(this.props.appState.longDateFormat)
        } as MUIDataTableColumnOptions
      },
      {
        name: '',
        options: {
          viewColumns: false,
          filter: false,
          setCellHeaderProps: () => ({ align: 'center' }),
          setCellProps: () => ({ align: 'center' }),
          customBodyRender: (value: boolean, tableMeta: MUIDataTableMeta) => {
            return (
              <>
                <IconButton
                  aria-label="edit"
                  color="primary"
                  className="text-primary"
                  size="small"
                  onClick={(e) => this.newCountryBufferPopup(tableMeta.rowData[0])}
                >
                    <EditOutlinedIcon />
                </IconButton>
                <IconButton
                  aria-label="delete"
                  color="inherit"
                  className="text-danger"
                  size="small"
                  onClick={(e) => this.deleteCountryBuffer(e, tableMeta)}
                >
                  <DeleteOutlineTwoToneIcon />
                </IconButton>
              </>
            );
          }
        }
      }];
    return columns;
  };

  deleteCountryBuffer = async (event: any, tableMeta: MUIDataTableMeta) => {
    try {
      const id = tableMeta.rowData[0];
      await this.organizationService.RemoveCountryBuffer(id);
      await this.loadCountryBuffers();
      this.props.enqueueSnackbar(this.translatorService.Tranlate('SUCCES_MSG', 'OK'), {
        variant: 'success'
      });
    } catch (error) {
      this.props.enqueueSnackbar(this.translatorService.Tranlate('ERROR_MSG', 'Eroare'), {
        variant: 'error'
      });
    }
  };

  newCountryBufferPopup = async (countryBufferId: number | null) => {
    let newCountryBuffer: CountryBuffer;
    if (countryBufferId == null) {
      newCountryBuffer = { ...this.state.newCountryBuffer } as CountryBuffer;
    } else {
      newCountryBuffer = this.state.countryBuffers.find((item) => item.id === countryBufferId)!;
    }
    this.setState({
      isDialogOpen: true,
      newCountryBuffer: newCountryBuffer,
      newCountryBufferId: countryBufferId
    });
  };

  closeDialog = async () => {
    this.setState(
        { 
          isDialogOpen: false, 
          newCountryBuffer: this.newCountryBuffer 
        }
      );
  };

  public render() {
    this.translatorService = (this.context as AppContext).translatorService;
    this.organizationService = (this.context as AppContext).organizationService;
    this.appReferentialService = (this.context as AppContext).referentialService;
    const options = {
      filter: true,
      selectableRows: 'none' as SelectableRows,
      selectableRowsOnClick: false,
      print: false,
      download: false,
      textLabels: MUITranslations.GetTranslations(this.translatorService),
      sort: false,
      // responsive: "stacked",
      customToolbar: () => {
        return (
          <Tooltip title={this.translatorService.Tranlate('Add', 'Adauga')}>
            <IconButton
              aria-label="add"
              color="secondary"
              className="m-2"
              onClick={(e) => this.newCountryBufferPopup(null)}
            >
              <AddCircleTwoToneIcon />
            </IconButton>
          </Tooltip>
        );
      }
    };
    return (
      <Fragment>
    
       <Box mt={1} pt={1}>
          <div className="d-flex flex-row text-center flex-wrap justify-content-center">
            <ScaleLoader color={'var(--primary)'} loading={this.state.isLoading} />
          </div>
          {!this.state.isLoading ? (
            <MUIDataTable
              title={''}
              data={this.state.countryBuffers}
              columns={this.getColumns()}
              options={options}
            />
          ) : null}
        </Box>
        {this.state.isDialogOpen ? (
          <Dialog
            onClose={this.closeDialog}
            aria-labelledby="customized-dialog-title"
            open={this.state.isDialogOpen}
            fullWidth={true}
            maxWidth={'sm'}
          >
            <DialogTitle id="customized-dialog-title">
              <Grid container>
                <Grid item xs={11}>
                  <Typography variant="h4">
                  {!this.state.newCountryBufferId ? 
                    this.translatorService.Tranlate(
                      'COUNTRY_BUFFER_ADD_MODAL_TITLE',
                      'Adauga buffer zile pe tara'
                    ) : this.translatorService.Tranlate(
                      'COUNTRY_BUFFER_UPDATE_MODAL_TITLE',
                      'Actualizeaza buffer zile pe tara'
                    )}               
                  </Typography>
                </Grid>
                <Grid item xs={1}>
                  <IconButton aria-label="close" onClick={this.closeDialog} size={'small'}>
                    <CloseIcon />
                  </IconButton>
                </Grid>
              </Grid>
            </DialogTitle>
            <DialogContent dividers>{this.renderAddForm()}</DialogContent>
          </Dialog>) : null}
      </Fragment>
    );
  }
}
export default connect(
  (state: ApplicationState) => ({
    appState: state.app
  }),
  null
)(withSnackbar(CountryBufferComponent as any));